import { render, staticRenderFns } from "./AttachmentItemNodeView.vue?vue&type=template&id=7ef00c88&scoped=true"
import script from "./AttachmentItemNodeView.vue?vue&type=script&lang=ts"
export * from "./AttachmentItemNodeView.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentItemNodeView.vue?vue&type=style&index=0&id=7ef00c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef00c88",
  null
  
)

export default component.exports